export default {
  createNewGroup: 'Create New Group',
  createYourGroup: 'Create Your Group',
  legend: 'Shape your group space.',
}
